"use client";

import { PusherProvider } from "@/components/realtime";
import { getPusherConfig } from "@/utils/backend_endpoint";
import { Tooltip } from "@deputy-ai/ui/tooltip/Tooltip";
import { loader } from "@monaco-editor/react";
import Pusher from "pusher-js";
import type { PropsWithChildren } from "react";
import { useEffect, useState, useMemo } from "react";

// Configure Monaco Editor loader
loader.config({
  paths: {
    vs: "https://www.unpkg.com/monaco-editor/min/vs",
  },
});

export function WithPusher({ children }: PropsWithChildren) {
  const pusherConfig = useMemo(getPusherConfig, []);
  const [pusher, setPusher] = useState<Pusher | undefined>(undefined);

  useEffect(() => {
    const pusher = new Pusher(pusherConfig.key, {
      ...pusherConfig,
      disableStats: true,
      enabledTransports: ["ws", "wss"],
      cluster: "gccloud",
    });
    setPusher(pusher);
  }, []);
  if (!pusher) {
    return null;
  }
  return <PusherProvider client={pusher}>{children}</PusherProvider>;
}

export function WithTooltip({ children }: PropsWithChildren) {
  return <Tooltip.Provider delayDuration={100}>{children}</Tooltip.Provider>;
}
